"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PlusIcon = _ref => {
  let {
    isActive
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "item-cell expand-grid"
  }, isActive ? /*#__PURE__*/_react.default.createElement("i", {
    className: "fbr-icon-plus is-active"
  }) : /*#__PURE__*/_react.default.createElement("i", {
    className: "fbr-icon-plus"
  }));
};
var _default = exports.default = PlusIcon;